import { SaveButton } from "components/Buttons"
import React from "react"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"
import {
  getCodesList,
  hideReinstateCodeModal,
  reinstateCode,
} from "store/actions"

const ReinstateCodeModal = ({
  code,
  loading,
  reinstateCode,
  hideReinstateCodeModal,
  getCodesList,
}) => {
  return (
    <React.Fragment>
      <Row>
        <Col>
          <h6>
            By reinstating the code you'll revert any previous assignment.
          </h6>
        </Col>
      </Row>
      <Row>
        <Col>
          <h6>Are you sure you want to reinstate?</h6>
        </Col>
      </Row>
      <Row className="d-flex justify-content-end mt-3">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Cancel"
            color="danger"
            onClick={hideReinstateCodeModal}
          />
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Reinstate"
            onClick={() => {
              reinstateCode({
                values: {
                  code: code?.code,
                  type: code?.role?.toLowerCase(),
                },
                callback: () => {
                  getCodesList({
                    bch: 0,
                    o: "created_at",
                    od: "desc",
                    page: 1,
                  })
                },
              })
            }}
            loading={loading}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  loading: state.codes.loading,
})

const mapDispatchToProps = dispatch => ({
  reinstateCode: values => dispatch(reinstateCode(values)),
  hideReinstateCodeModal: () => dispatch(hideReinstateCodeModal()),
  getCodesList: values => dispatch(getCodesList(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ReinstateCodeModal)
